import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useCompanyPageStore } from "@/store/companyPageStore";
import { IntentFilters } from "./components/Intent/IntentFilters";
import { IntentTable } from "./components/Intent/IntentTable";
import { useCompanyIntentTopicsHydration } from "./components/Intent/hooks/useCompanyIntentTopicsHydration";

/**
 * Intent tab view for Company Profile page
 * Shows intent activity table with filters and context sidebar
 */
export const IntentView = () => {
  const company = useCompanyPageStore((state) => state.company);
  useCompanyIntentTopicsHydration();

  if (!company) return null;

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Divider sx={{ my: 1 }} />
      <Box mb={2}>
        <IntentFilters />
      </Box>
      <Card
        sx={{
          p: 3,
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack direction="row" alignItems="center" mb={2}>
          <Typography variant="h4" fontWeight="bold">
            Intent Activity
          </Typography>
        </Stack>
        <Box flex={1} minHeight={0} overflow="hidden">
          <IntentTable />
        </Box>
      </Card>
    </Box>
  );
};
